import callApi, { ENDPOINTS } from 'utils/api/callApi'

interface ILocation {
  city: string
  stateCode: string
  radiusMiles: number
}

export interface ICallListParams {
  origin: ILocation
  destination: ILocation
  source: string
  shipperApplicationId?: string
  equipmentId: string
}

export interface ICallListResponse {
  message: string
}

/**
 * Makes a request for a Carrier CSV file that will be sent to the requester's Slack via message
 * @method POST
 * @param {ICallListParams} callListBody
 * @returns ICallListResponse
 */
export const requestCarrierCallList = (callListBody: ICallListParams): Promise<ICallListResponse> =>
  callApi({
    endpoint: ENDPOINTS.laneMatchedCarriers,
    method: 'POST',
    body: callListBody,
  })
